const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const ApplicationAdd = () => import(/* webpackChunkName: "apps" */ './view/add.vue');
const ApplicationEdit = () => import(/* webpackChunkName: "apps" */ './view/edit.vue');
const ApplicationList = () => import(/* webpackChunkName: "apps" */ './view/index.vue');

export const ROUTE_NAME_APPLICATION = {
    INDEX: 'ApplicationList',
    ADD: 'ApplicationAdd',
    EDIT: 'ApplicationEdit'
} as const;

export default [
    {
        path: '/apps',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                name: ROUTE_NAME_APPLICATION.INDEX,
                component: ApplicationList,
                meta: { requiresAuth: true }
            },
            {
                path: ':id/edit',
                name: ROUTE_NAME_APPLICATION.EDIT,
                component: ApplicationEdit,
                meta: { requiresAuth: true }
            },
            {
                path: 'add',
                name: ROUTE_NAME_APPLICATION.ADD,
                component: ApplicationAdd,
                meta: { requiresAuth: true }
            }
        ]
    }
];
